module.exports = __webpack_public_path__ + "b64cd5cb65ee5e6b74e6ede787308e40.png";